var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBellOutlined(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.55554 0C5.82762 0 2.80554 3.02208 2.80554 6.75V10.6972L0.973493 13.4453C0.768922 13.7522 0.74985 14.1467 0.923869 14.4719C1.09789 14.797 1.43675 15 1.80554 15H17.3055C17.6743 15 18.0132 14.797 18.1872 14.4719C18.3612 14.1467 18.3422 13.7522 18.1376 13.4453L16.3055 10.6972V6.75C16.3055 3.02208 13.2835 0 9.55554 0ZM4.80554 6.75C4.80554 4.12665 6.93219 2 9.55554 2C12.1789 2 14.3055 4.12665 14.3055 6.75V11C14.3055 11.1974 14.364 11.3904 14.4735 11.5547L15.437 13H3.67406L4.63759 11.5547C4.74711 11.3904 4.80554 11.1974 4.80554 11V6.75ZM11.8055 16C11.8055 17.1046 10.9101 18 9.80554 18C8.70097 18 7.80554 17.1046 7.80554 16H11.8055Z",
    fill: "#666666"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBellOutlined);
export default __webpack_public_path__ + "static/media/BellOutlined.d53f45e8.svg";
export { ForwardRef as ReactComponent };